import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Header from "./components/HeaderThree";
import IntroOverlay from "./components/IntroOverlay";

import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer3";
import DisclaimerPopup from "./components/DisclaimerPopup";

// Pages 
import Home from "./pages/Home";
import AboutPage from "./pages/AboutUsPage";
import ProjectUspage from "./pages/ProjectUspage";
import ContactUs from "./pages/ContactUsPage";

// Project Page 
import SereneSite from "./pages/SereneSite";
import PalmsSite from "./pages/PalmsSite";
import MeadowsSite from "./pages/MeadowsSite";
import WoodsSite from "./pages/WoodsSite";
import VillasSite from "./pages/VillasSite";
import UpcomingProjectPage from "./pages/UpcomingProjectPage";
import MokhilaLogo from "./assets/images/mokila-logo.png";
import KarimnagarLogo from "./assets/images/karimnagar-logo.png";
import KismathpurLogo from "./assets/images/kismathpur-logo.png";
import NarsingiLogo from "./assets/images/narsingi-logo.png";
import UpcomingBg from "./assets/images/bg-min.jpg";
import CyberMeadows from "./pages/CyberMeadows";



import "./styles/style.css";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <BrowserRouter>
      {showIntro && (
        <IntroOverlay onFinish={() => setShowIntro(false)} />
      )}

      {!showIntro && (
        <>
          <ScrollToTop />

          {/* <Header /> */}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/serene" element={<SereneSite />} />
            <Route path="/palms" element={<PalmsSite />} />
            <Route path="/meadows" element={<MeadowsSite />} />
            <Route path="/woods" element={<WoodsSite />} />
            <Route path="/villas" element={<VillasSite />} />
            <Route path="/cyber-meadows" element={<CyberMeadows />} />
            <Route
              path="/mokilla"
              element={(
                <UpcomingProjectPage
                  title="Mokhila"
                  logo={MokhilaLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/mokhila"
              element={(
                <UpcomingProjectPage
                  title="Mokhila"
                  logo={MokhilaLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/karimnagar"
              element={(
                <UpcomingProjectPage
                  title="Karimnagar"
                  logo={KarimnagarLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/kismathpur"
              element={(
                <UpcomingProjectPage
                  title="Kismathpur"
                  logo={KismathpurLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/kishmathpur"
              element={(
                <UpcomingProjectPage
                  title="Kishmathpur"
                  logo={KismathpurLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/narsingi"
              element={(
                <UpcomingProjectPage
                  title="Narsingi"
                  logo={NarsingiLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/projects" element={<ProjectUspage />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>

          <DisclaimerPopup />
          <ScrollToTop />
          <Footer />
        </>
      )}
    </BrowserRouter>
  );
}


export default App;
